import React from "react";
import { Box, Stack } from "@mui/material";
import TriviaDailyHero from "../trivia/TriviaDailyHero";
import TriviaGameHUD from "../trivia/TriviaGameHUD";
import TriviaModeCard from "../trivia/TriviaModeCard";
import TriviaPlayerOptionCard from "../trivia/TriviaPlayerOptionCard";
import TriviaQuestionStage from "../trivia/TriviaQuestionStage";
import { MARKETING_TRIVIA_QUESTION } from "./marketingProductShowcases";

const MarketingTriviaPlayPreview = ({ onPlay }) => (
  <Box sx={{ maxWidth: 880, mx: "auto" }}>
    <TriviaDailyHero
      date="2026-08-21"
      played={false}
      participantCount={12840}
      onPlay={onPlay}
      reducedMotion
    />
    <Stack direction={{ xs: "column", md: "row" }} spacing={2} sx={{ mb: 4 }}>
      <TriviaModeCard
        title="Quick Play"
        subtitle="5 questions · Medium · Career stats · 30s"
        cta="Play now"
        onClick={onPlay}
      />
      <TriviaModeCard
        title="Custom"
        subtitle="Pick category, difficulty, count, and timer"
        cta="Configure"
        onClick={onPlay}
      />
    </Stack>
    <Box
      sx={{
        p: { xs: 2, md: 3 },
        borderRadius: 3,
        border: "1px solid rgba(236, 72, 153, 0.2)",
        bgcolor: "#0a0a0a",
      }}
    >
      <TriviaGameHUD
        currentIndex={2}
        total={10}
        score={240}
        timeLeft={18}
        timeLimit={30}
        streak={3}
        onQuit={onPlay}
        reducedMotion
      />
      <TriviaQuestionStage question={MARKETING_TRIVIA_QUESTION} />
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr 1fr", md: "repeat(4, 1fr)" },
          gap: 1.5,
        }}
      >
        {MARKETING_TRIVIA_QUESTION.options.map((option) => (
          <TriviaPlayerOptionCard
            key={option.playerId}
            option={option}
            sport="mlb"
            onSelect={onPlay}
          />
        ))}
      </Box>
    </Box>
  </Box>
);

export default MarketingTriviaPlayPreview;
